import React from "react";
import logo from '@/assets/images/footer/common/logo.png';
import serviceQR from '@/assets/images/footer/common/serviceQR.png';
// import xcxPng from '@/assets/images/footer/common/xcx.png';
import officialQR from '@/assets/images/footer/common/officialQR.png';
import policePng from '@/assets/images/footer/common/police.png';
import styles from './index.module.scss';

const WebFooter = () => {
    return (
        <div className={styles.footer_box}>
            <div className={styles.scan_code}>
                <img src={logo} alt="" className={styles.logo} />
                <div className={styles.QR_code}>
                     <img src={serviceQR} alt="" className={styles.serviceQR} />
                    {/*<img src={xcxPng} alt="" className={styles.xcxPng} />*/}
                    <img src={officialQR} alt="" className={styles.officialQR} />
                </div>
            </div>
            <div className={styles.bottom_frame}>
                <span><a target="blank" className={styles.beian} href="https://beian.miit.gov.cn">Ⓒ 成都雷石天地电子技术有限公司 蜀ICP备2024089085号</a></span>
                <span>
                    <a target="blank" className={styles['beian-record']} href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51015602001010">
                        <img src={policePng} alt="" />
                        川公网安备 51015602001010号
                    </a>
                </span>
                <span>增值电信业务经营许可证：<a target="blank" href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%25E5%25B7%259DB2-20250869&type=xuke">川B2-20250869 </a></span>
                <span>不良信息/涉未成年举报邮箱：yuxi.zhu@cdthunder.com</span>
                <span>不良信息/涉未成年举报电话：17711571534</span>
                <span>四川省互联网违法和不良信息举报中心：<a target="blank" href="https://www.scjb.gov.cn">https://www.scjb.gov.cn</a></span>
                <span>网络从业者不良行为举报：yuxi.zhu@cdthunder.com</span>
                <span>中国互联网举报中心电话：<a target="blank" href="http://www.12377.cn">12377</a></span>
            </div>
        </div>
    );
};

export default WebFooter;